import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";

interface registerUserState {
	response: string | null;
	registerUserLoading: boolean;
	registerUserError: string | null;
}

const initialState: registerUserState = {
	response: null,
	registerUserLoading: false,
	registerUserError: null
}

export const registerUser = createAsyncThunk(
	'auth/register',
	async (credentials: any, { rejectWithValue }) => {
		try {
			const response = await axios.post('user/register', credentials.data, {
				headers: { Authorization: `Bearer ${credentials.token}` }
			})
			return response.data;
		} catch (authError: any) {
			return rejectWithValue(authError.message || 'An error occured');
		}
	}
);
// export const registerUser = createAsyncThunk(
// 	'auth/registerUser',
// 	async (credentials: any, { rejectWithValue }) => {
// 		try {
// 			const response = await apiClient.post('user/register', credentials);
// 			return response.data;
// 		} catch (registerUserError: any) {
// 			return rejectWithValue(registerUserError.response.data || 'An error occured');
// 		}
// 	}
// );

const registerUserSlice = createSlice({
	name: 'registerUser',
	initialState,
	reducers: {
		reset: () => initialState
	},
	extraReducers: (builder) => {
		//user registration reducers
		builder.addCase(registerUser.pending, (state) => {
			state.registerUserLoading = true;
			state.registerUserError = null;
		});
		builder.addCase(registerUser.fulfilled, (state, action) => {
			state.response = action.payload;
			state.registerUserError = null;
			state.registerUserLoading = false;
		});
		builder.addCase(registerUser.rejected, (state, action) => {
			state.registerUserLoading = false;
			state.registerUserError = action.payload as string;
		});

	}
});

export const { reset } = registerUserSlice.actions;
export default registerUserSlice.reducer;
